<script>
import appConfig from "@/app.config";
import { layoutComputed } from '@/state/helpers.js'
export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    } 
  },
  computed: {
    ...layoutComputed
  },
  mounted() {
    this.initSiteLayout()
  },
  methods: {
    initSiteLayout() {
      document.body.setAttribute('data-layout', this.layoutType)
      // document.body.setAttribute('data-sidebar', this.leftSidebarType)
      document.body.setAttribute('data-sidebar-size', this.layoutWidth)
      document.body.setAttribute('data-bs-theme', this.mode)
      if (this.dir === 'rtl') {
        document.body.setAttribute('dir', this.dir)        
      }
    }
  }
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
<style>

/* =========================================
   1. GAYA HEADER TABEL (MODERN LOOK)
   ========================================= */
.table thead th {
    background-color: #eff2f7; /* Warna abu-abu kebiruan soft */
    color: #495057;            /* Warna teks abu-abu gelap */
    font-weight: 600;          /* Tebal */
    text-transform: uppercase; /* Huruf Kapital */
    font-size: 0.75rem;        /* Ukuran font pas */
    letter-spacing: 0.03em;    /* Jarak antar huruf */
    padding: 12px 15px;        /* Spacing atas bawah */
    border-top: none !important;
    border-bottom: 1px solid #e9ecef;
    vertical-align: middle;
}

/* =========================================
   2. PAKSA SCROLL HORIZONTAL (KIRI-KANAN)
   ========================================= */
/* Mencegah teks turun ke bawah (wrap). 
   Ini memaksa tabel melebar ke kanan sehingga scrollbar muncul */
.table th, 
.table td {
    white-space: nowrap; 
    vertical-align: middle; /* Rata tengah vertikal */
}

/* Pastikan container tabel bisa di-scroll */
.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto; /* Munculkan scrollbar horizontal jika perlu */
    -webkit-overflow-scrolling: touch; /* Scroll halus di mobile */
    border-radius: 6px; /* Sedikit melengkung di sudut */
}

/* =========================================
   3. KUSTOMISASI SCROLLBAR (AGAR LEBIH MENARIK)
   ========================================= */
/* Lebar/Tinggi Scrollbar */
.table-responsive::-webkit-scrollbar {
    height: 8px; /* Tinggi scrollbar horizontal */
    width: 8px;
}

/* Warna Track (Jalur) */
.table-responsive::-webkit-scrollbar-track {
    background: #f1f1f1; 
    border-radius: 4px;
}

/* Warna Handle (Batang Scroll) */
.table-responsive::-webkit-scrollbar-thumb {
    background: #c1c1c1; 
    border-radius: 4px;
}

/* Efek saat Hover di Scrollbar */
.table-responsive::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8; 
}


/* -------------- */


.form-label, 
label {
    font-weight: 600; /* Semi-bold */
    color: #495057;   /* Abu gelap */
    font-size: 0.85rem;
    margin-bottom: 0.5rem; /* Jarak antara label dan input */
}

/* --- Input Text, Number, Date, & Textarea --- */
.form-control {
    background-color: #fff;
    border: 1px solid #e2e5e8; /* Border abu sangat muda (Clean) */
    border-radius: 6px;        /* Sudut membulat modern */
    padding: 10px 15px;        /* Padding lebih lega agar tidak sempit */
    font-size: 0.875rem;
    color: #495057;
    transition: all 0.3s ease; /* Animasi halus saat diklik */
}

/* --- Dropdown / Select --- */
.form-select {
    border: 1px solid #e2e5e8;
    border-radius: 6px;
    padding: 10px 35px 10px 15px; /* Padding kanan lebih besar untuk panah */
    font-size: 0.875rem;
    color: #495057;
    transition: all 0.3s ease;
}

/* --- Efek saat Input di-klik (Focus State) --- */
.form-control:focus, 
.form-select:focus {
    border-color: #556ee6; /* Warna Primary (Biru) */
    box-shadow: 0 0 0 0.15rem rgba(85, 110, 230, 0.15); /* Efek Glow biru transparan */
    outline: none;
    background-color: #fff;
}

/* --- Input Read-Only / Disabled --- */
/* Memberikan background abu soft agar user tahu tidak bisa diedit */
.form-control:disabled, 
.form-control[readonly],
.form-select:disabled {
    background-color: #eff2f7; 
    border-color: #e2e5e8;
    color: #74788d; /* Teks sedikit lebih pudar */
    opacity: 1;
}

/* --- Input Group (Contoh: Rp ...) --- */
.input-group-text {
    background-color: #eff2f7;
    border: 1px solid #e2e5e8;
    color: #495057;
    font-weight: 600;
    border-radius: 6px; /* Menyesuaikan radius input */
}

/* --- Validation Error State (Bootstrap Override) --- */
.form-control.is-invalid, 
.form-select.is-invalid {
    border-color: #f46a6a; /* Merah soft */
    background-image: none; /* Menghilangkan icon pentung bawaan bootstrap yg kadang mengganggu */
}

.form-control.is-invalid:focus, 
.form-select.is-invalid:focus {
    box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.15); /* Glow merah */
}

/* --- Placeholder Text --- */
::placeholder {
    color: #adb5bd !important;
    font-size: 0.85rem;
    opacity: 1;
}
</style>
